export const Country = {
  US: 'US',
  CA: 'CA',
  USA: 'USA',
  CAN: 'CAN',
  United_States: 'United States of America',
} as const;
